import { Injectable } from "@angular/core";
import { Article } from "../../models/article.model";
import { EntityStoreService } from "../../../../shared/store/entity-store/entity-store.service";
import {
  EntityMetadata,
  EntityStoreState,
} from "../../../../shared/store/store-types.model";
import { ArticleFacadeService } from "./article-facade.service";
import { StatsArticle } from "../../models/stats-article.model";

@Injectable({ providedIn: "root" })
export class ArticleStoreService extends EntityStoreService<
  Article,
  EntityMetadata,
  ArticleState
> {
  constructor() {
    super({
      ...EntityStoreService.initialState,
      stats: null,
    });
  }
}

export interface ArticleState extends EntityStoreState<ArticleFacadeService> {
  stats: StatsArticle;
}
